var default_styles_default = {
  "button_container": "XpKkX",
  "button_text": "-ADwc",
  "button_size_content": "_08cLS"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
